module.exports = __webpack_public_path__ + "static/iterm-cf8becb6f0589afe8431e81d80fad870.png";